import { BusinessObjectBase, ModelBase, ObservableCollection } from '@skylab-shared/core';
import { DocumentPaymentListItemModel } from '@skylab-shared/dataModel';
import { Calc, MidpointRounding } from '@skylab-shared/utils';
import { CurrencyCollectionQuery } from '../../currency/queries/currency.query-base';

interface ModelPart extends ModelBase {
    currencyId: number;
    grossValue: number;
    payments: ObservableCollection<DocumentPaymentListItemModel>;
}

export abstract class ToPayMixin<TModel extends ModelPart> extends BusinessObjectBase<TModel>  {
    public get remainingAmountToPay(): number {
        const { precision } = this.localContext.firstPreloaded(CurrencyCollectionQuery, { id: this.model.currencyId })!;
        const remaining = Calc.round(Math.abs(this.model.grossValue) - this.paid, precision, MidpointRounding.AwayFromZero);

        return remaining;
    }

    public get paid(): number {
        if (this.model.currencyId === 0) {
            return 0;
        }

        const { precision } = this.localContext.firstPreloaded(CurrencyCollectionQuery, { id: this.model.currencyId })!;
        const paid = Calc.round(this.model.payments.reduce((sum, { value }) => sum + value, 0), precision, MidpointRounding.AwayFromZero);

        return paid;
    }
}
